<template>
  <div>
    <!-- <login-header v-bind="headerInfo"></login-header> -->
    <div class="content">
      <div class="app-head">
        <div class="app-head-txt"><img src="../../assets/img/head-txt.png" width="700" height="200"/></div>
        <div class="app-head-select clearfix">
          <div class="app-head-select-l">
              <div class="app-head-select-ewm"><img src="../../assets/img/app-ewm.jpg"/></div>
              <p>微信扫码下载</p>
          </div>
          <div class="app-head-select-r">
            <div class="app-head-tips">商家店铺的<strong>移动管理工具</strong></div>
            <div class="app-head-btn">
              <!-- <a href="javascript:void(0)" class="appley-btn"><img src="../../assets/img/icon-apple.png"/>ios版下载</a> -->
              <a href="javascript:void(0)" class="android-btn"><img src="../../assets/img/icon-android.png"/>Android版下载</a>
							<div class="onlyandroid">仅支持安卓手机下载</div>
            </div>
          </div>
        </div>
      </div>

      <div class="gnjs-group">
        <div class="sort-box">
          <p class="small">商家APP</p>
          <p class="big">V1.0</p>
        </div>
        <div class="box-tit">
          <span>功能介绍</span>
        </div>
        <div class="box-con"><span class="black">商家APP1.0版本功能包括：</span>门店管理、商品管理、营收统计、订单管理、售后管理等主要功能。</br>用户可使用手机完成门店的信息查看、商品上下架操作、订单发货改价等操作、售后订单的处理、营销收入的查看等操作</div>
        <div class="box-img img-gnzs"></div>
      </div>

      <div class="app-group mdgl-group">
        <div class="mdgl-item">
          <div class="group-tit">门店管理</div>
          <div class="group-con">用户通过门店管理查看店铺信息，包括店铺有效期限、联系方式等信息。可以查看店铺二维码并将二维码保存到相册，店铺二维码可用于引导消费者扫码关注店铺和展示店铺。</div>
        </div>
      </div>

      <div class="blue-bg">
        <div class="app-group spgl-group">
          <div class="spgl-item">
            <div class="group-tit">商品管理</div>
            <div class="group-con">用户可查看发布的商品，并对商品进行上下架、修改价格、修改销量、删除、搜索等操作</div>
          </div>
        </div>

        <div class="app-group ddgl-group">
          <div class="ddgl-item clearfix">
            <div class="ddgl-tit"></div>
            <div class="ddgl-con">
              <p><strong>订单查看：</strong>用户可以通过手机客户端查看商城的订单信息和新单详情信息。</p>
              <p><strong>订单处理：</strong>用户可以对订单进行操作，包括：改价、发货、确认收货、添加备注、查看物流等操作</p>
              <p><strong>发货：</strong>用户使用手机APP发货时，可以运用扫码功能，通过扫描运单的二维码自动识别运单号，免去手动输入的麻烦</p>
            </div>
          </div>
        </div>

        <div class="app-group shgl-group">
          <div class="shgl-item">
            <div class="shgl-tit">售后管理</div>
            <div class="shgl-con">
              <p><strong>售后订单查看：</strong>用户可以通过手机客户端查看商城的售后订单，包括退款订单和退货退款订单</p>
              <p><strong>售后订单处理：</strong>用户可以对售后订单进行处理，包括：同意退款、拒绝退款、确认收货、添加备注、查看物流等操作</p>
              <p><strong>协商历史：</strong>在这里可以查看售后订单处理流程</p>
            </div>
          </div>
        </div>
      </div>

      <div class="app-group shgl-group ystj-group">
        <div class="shgl-item">
          <div class="shgl-tit">营收统计</div>
          <div class="shgl-con">
            <p>用户进入营收统计可以通过日期筛选搜索、查看收支明细及付款人数、待付款单数、付款金额，订单信息和收入情况一目了然。</p>
          </div>
        </div>
      </div>

      <div class="app-group shgl-group xtsz-group">
        <div class="shgl-item">
          <div class="shgl-tit">系统设置</div>
          <div class="shgl-con">
            <p><strong>员工设置：</strong>用户进入系统设置页面，可以对员工进行设置，包括：修改员工信息、删除员工、开启或关闭员工</p>
            <p><strong>切换店铺：</strong>通过店铺切换入口进入，切换、管理此账户下的不同店铺。</p>
            <p><strong>联系客服：</strong>企迈云商将随时随地为您提供服务支持</p>
          </div>
        </div>
      </div>

      <div class="back-btn-out">
        <a href="#" class="back-btn">我已了解，立即返回 ></a>
      </div>
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
// 头部模块
import loginHeader from '../header'
// 底部模块
import loginFooter from '../footer'
// 滑动验证模块
import qs from 'qs'

export default {
  name: 'login',

  // 导入子组件
  components: {
    loginHeader, // 头部模块
    loginFooter // 底部模块
  },

  data() {
    return {
      headerInfo: { // 头部
        type: '绑定账号',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: '' // 底部
    }
  },
  created() {

  },
  methods: {

  }

}
</script>

<style scoped>
.content{
  width: 100%;
  margin: 0 auto;
}
*,
:before,
:after {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box
}

body,ul,li,ol,h1,h2,h3,h4,h5,h6,p,div,dl,dt,dd {
	padding: 0;
	margin: 0;
	list-style-type: none;
	font-size: 14px;
}

body {
	font-family: '微软雅黑';
	font-size: 14px;
	color: #666666;
	/* width: 100%;
	height: 100%; */
	overflow-x: hidden;
	background-color: #eceff3;
	overflow-y: auto;
	min-width: 1240px;
}

p {
	margin-bottom: 0;
}

img {
	max-width: 100%;
}

a {
	color: #666666;
	-webkit-transition: color .2s;
	-moz-transition: color .2s;
	-o-transition: color .2s;
	transition: color .2s;
}

a:link,
a:visited {
	text-decoration: none;
}

a:hover,
a:active {
	text-decoration: none;
}

a:focus {
	outline: none;
	-moz-outline: none;
}

* html .clearfix {
	height: 1%;
}

html[xmlns] .clearfix {
	display: block;
}

.clearfix:after {
	content: "";
	display: block;
	height: 0;
	clear: both;
	visibility: hidden;
}

button,
input {
	outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

::-webkit-input-placeholder {
	color: #999;
}

select {
	outline: none;
}

.app-wrap{
	width: 1120px;
	margin: 0 auto;
	position: relative;
}

.app-head{
	height:960px;
	background-color:#609ee9;
	background-image:url(../../assets/img/head-bg.jpg);
	background-position:center bottom;
	background-size:100% auto;
	background-repeat:no-repeat;
	overflow:hidden;
}
.app-head-txt img{
	display:block;
	margin:120px auto 0;
}
.app-head-select{
	width:880px;
	margin:90px auto 0;
}
.app-head-select-l{
	width:310px;
	float:left;
}
.app-head-select-ewm{
	width:310px;
	height:310px;
	overflow:hidden;
	background-color:#fff;
	-moz-border-radius:10px;
	-webkit-border-radius:10px;
	border-radius:10px;
}
.app-head-select-l p{
	margin-top: 24px;
	text-align:center;
	color:#fff;
	font-size:18px;
}
.app-head-select-r{
	float:right;
}
.app-head-tips{
	text-align:right;
	color:#fff;
	font-size:44px;
	font-weight:lighter;
	letter-spacing:3px;
	margin:40px 0 60px;
}
.app-head-btn{
	/* text-align:right; */
	font-size:0;
}
.app-head-btn a{
	color:#fff;
	font-size:22px;
	width:240px;
	height:66px;
	line-height:66px;
	text-align:center;
	display:inline-block;
	vertical-align:middle;
	border:1px solid #fff;
	-moz-border-radius:5px;
	-webkit-border-radius:5px;
	border-radius:5px;
}
/*.app-head-btn a:hover{
	background: transparent;
	background-color:rgba(255,255,255,0.1);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff, endColorstr=#ffffff);
}*/
.app-head-btn a img{
	width:40px;
	height:40px;
	display:inline-block;
	vertical-align:middle;
	margin-top:-3px;
	margin-right:5px;
}
.android-btn{
	/* margin-left:40px; */
}
.gnjs-group{
	width:1120px;
	height:650px;
	margin:50px auto;
	overflow:hidden;
	background-color:#fff;
	-moz-border-radius:25px;
	-webkit-border-radius:25px;
	border-radius:25px;
	position:relative;
	-webkit-box-shadow:0 0 15px #e7e7e7;
	-moz-box-shadow:0 0 15px #e7e7e7;
	box-shadow:0 0 15px #e7e7e7;
}
.gnjs-group .sort-box{
	position:absolute;
	left:70px;
	top:0;
	width:120px;
	height:140px;
	padding-top:25px;
	background-image:url(../../assets/img/sort-bg.jpg);
	background-position:center bottom;
	background-size:100% 100%;
	background-repeat:no-repeat;
}
.gnjs-group .sort-box p{
	color:#fff;
	text-align:center;
}
.gnjs-group .sort-box p.small{
	font-size:22px;
}
.gnjs-group .sort-box p.big{
	font-size:42px;
}
.gnjs-group .box-tit{
	margin:35px auto 0;
	width:320px;
	height:80px;
	line-height:80px;
	text-align:center;
	background-image:url(../../assets/img/box-tit.jpg);
	background-position:center bottom;
	background-size:100% 100%;
	background-repeat:no-repeat;
}
.gnjs-group .box-tit span{
	display:inline-block;
	vertical-align:middle;
	font-size:32px;
	color:#fff;
	position:relative;
}
.gnjs-group .box-tit span:after{
	content:"";
	position:absolute;
	left:-40px;
	top:50%;
	margin-top:-1px;
	width:25px;
	height:2px;
	background: transparent;
	background-color:rgba(255,255,255,0.3);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff, endColorstr=#ffffff);
}
.gnjs-group .box-tit span:before{
	content:"";
	position:absolute;
	right:-40px;
	top:50%;
	margin-top:-1px;
	width:25px;
	height:2px;
	background: transparent;
	background-color:rgba(255,255,255,0.3);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#ffffff, endColorstr=#ffffff);
}
.gnjs-group .box-con{
	width:850px;
	margin:30px auto 0;
	text-align:center;
	text-indent:2em;
	font-size:16px;
	line-height:30px;
}
.black{
	color:#232323;
}
.img-gnzs{
	width:800px;
	height:420px;
	position:absolute;
	bottom:0;
	left:50%;
	margin-left:-400px;
	background-image:url(../../assets/img/img-gnzs.jpg);
	background-position:center bottom;
	background-size:100% 100%;
	background-repeat:no-repeat;
}
.app-group{
	width:1120px;
	margin:0 auto;
	overflow:hidden;
}
.mdgl-group{
	height:600px;
	background-image:url(../../assets/img/img-mdgl.jpg);
	background-position:right center;
	background-size:680px 600px;
	background-repeat:no-repeat;
}
.mdgl-item{
	width:420px;
	margin-top:150px;
	padding-left:60px;
}
.group-tit{
	font-weight:lighter;
	font-size:42px;
	color:#222222;
	position:relative;
}
.group-tit:before,.shgl-tit:before{
	content:"";
	position:absolute;
	left:-40px;
	top:50%;
	margin-top:-9px;
	width:18px;
	height:18px;
	background-image:url(../../assets/img/black-cicle.jpg);
	background-position:left center;
	background-size:18px 18px;
	background-repeat:no-repeat;
}
.group-con{
	margin-top:20px;
	font-size:16px;
	line-height:40px;
}
.spgl-group{
	min-height:750px;
	background-image:url(../../assets/img/img-spgl.png);
	background-position:center bottom;
	background-size:900px 600px;
	background-repeat:no-repeat;
}
.spgl-item{
	width:420px;
	padding-left:60px;
}
.blue-bg{
	background-image:url(../../assets/img/blue.png);
	background-position:center 356px;
	background-size:1920px auto;
	background-repeat:no-repeat;
}
.ddgl-group{
	height:780px;
	background-image:url(../../assets/img/img-ddgl.png);
	background-position:right bottom;
	background-size:1100px 480px;
	background-repeat:no-repeat;
}
.ddgl-tit{
	float: left;
	width:230px;
	height:250px;
	background-image:url(../../assets/img/ddgl-tit.jpg);
	background-position:right center;
	background-size:100% 100%;
	background-repeat:no-repeat;
}
.ddgl-con{
	padding-top:100px;
	float:right;
	color:#fff;
	width:800px;
	font-size:16px;
	line-height:40px;
}
.shgl-group{
	height:700px;
	margin-top:150px;
	background-image:url(../../assets/img/img-shgl.jpg);
	background-position:center bottom;
	background-size:1100px 480px;
	background-repeat:no-repeat;
}
.shgl-item{
	padding-left:60px;
}
.shgl-tit{
	font-weight:lighter;
	font-size:42px;
	color:#222222;
	position:relative;
}
.shgl-con{
	width:800px;
	margin-top: 20px;
    font-size: 16px;
    line-height: 40px;
}
.shgl-con strong{
	color:#333333;
}
.ystj-group{
	height:800px;
	margin-top:50px;
	background-size:1100px 650px;
	background-image:url(../../assets/img/img-ystj.jpg);
}
.xtsz-group{
	margin-top:50px;
	background-image:url(../../assets/img/img-xtsz.jpg);
}
.back-btn-out{
	padding:150px 0;
}
.back-btn{
	width:350px;
	height:60px;
	line-height:60px;
	display:block;
	margin:0 auto;
	color:#fff;
	font-size:20px;
	background-color:#609ee9;
	-moz-border-radius:50px;
	-webkit-border-radius:50px;
	border-radius:50px;
	text-align:center;
}
.onlyandroid {
	color: #fff;
	font-size: 18px;
	margin-top: 14px;
}
</style>